module.exports = __webpack_public_path__ + "static/media/FestAkt.bb64a98d.jpg";